var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalanceDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8904 11.3083C12.9476 11.2469 13.0166 11.1977 13.0933 11.1635C13.17 11.1293 13.2527 11.111 13.3366 11.1095C13.4205 11.108 13.5039 11.1234 13.5817 11.1549C13.6596 11.1863 13.7302 11.2331 13.7896 11.2924C13.8489 11.3518 13.8957 11.4225 13.9272 11.5003C13.9586 11.5781 13.974 11.6615 13.9726 11.7454C13.9711 11.8293 13.9527 11.9121 13.9186 11.9888C13.8844 12.0654 13.8351 12.1344 13.7737 12.1916L10.4404 15.525C10.3232 15.642 10.1644 15.7078 9.99873 15.7078C9.83311 15.7078 9.67425 15.642 9.55707 15.525L6.22373 12.1916C6.16233 12.1344 6.11308 12.0654 6.07892 11.9888C6.04476 11.9121 6.02639 11.8293 6.02491 11.7454C6.02343 11.6615 6.03886 11.5781 6.0703 11.5003C6.10173 11.4225 6.14852 11.3518 6.20787 11.2924C6.26722 11.2331 6.33791 11.1863 6.41574 11.1549C6.49356 11.1234 6.57692 11.108 6.66083 11.1095C6.74475 11.111 6.82752 11.1293 6.90418 11.1635C6.98085 11.1977 7.04985 11.2469 7.10707 11.3083L9.37373 13.575V5.49998C9.37373 5.33422 9.43958 5.17525 9.55679 5.05804C9.674 4.94083 9.83297 4.87498 9.99873 4.87498C10.1645 4.87498 10.3235 4.94083 10.4407 5.05804C10.5579 5.17525 10.6237 5.33422 10.6237 5.49998L10.6237 13.575L12.8904 11.3083Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceDown);
export default __webpack_public_path__ + "static/media/BalanceDown.38666b75329f6eebf0b43f1df6421777.svg";
export { ForwardRef as ReactComponent };